module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn ringingHolds"
  }, [_c('filters', {
    attrs: {
      "scope": _vm.filtersScope
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "statistic-wrap"
  }, [_c('div', {
    staticClass: "card statistic-table"
  }, [_c('div', [_c('div', {
    staticClass: "card-block"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_vm._v("Прозвон холдов")]), _vm._v(" "), _c('table', {
    staticClass: "table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.rows), function(row) {
    return _c('tbody', [_c('tr', [_c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.date) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.total_processed) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.average_changes) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(224, 224, 224)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.average_calls) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_one_day_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_one_day_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_one_day_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 249, 196)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_one_day_ago > 0 ? ((row.approved_one_day_ago / row.created_one_day_ago) * 100).toFixed(1) + '%' : '0%') + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_two_days_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_two_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_two_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 230, 155)"
      }
    }, [_vm._v(_vm._s(row.created_two_days_ago > 0 ? ((row.approved_two_days_ago / row.created_two_days_ago) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_three_days_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 224, 131)"
      }
    }, [_vm._v(_vm._s(row.approved_three_days_ago > 0 ? ((row.approved_three_days_ago / row.created_three_days_ago) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.ring_up_more_three_days_ago) + "%\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.created_more_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v("\n                                    " + _vm._s(row.approved_more_three_days_ago) + "\n                                ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(255, 217, 106)"
      }
    }, [_vm._v(_vm._s(row.created_more_three_days_ago > 0 ? ((row.approved_more_three_days_ago / row.created_more_three_days_ago) * 100).toFixed(1) + '%' : '0%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(129, 199, 132)"
      }
    }, [_vm._v(_vm._s(row.total_approved))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(129, 199, 132)"
      }
    }, [_vm._v(_vm._s(((row.total_approved / row.total_processed) * 100).toFixed(1) + '%'))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "background-color": "rgb(129, 199, 132)"
      }
    }, [_vm._v(_vm._s(_vm.approvedFromValid(row.total_approved, row.total_processed, row.total_spam)))])])])
  }), _vm._v(" "), _c('tfoot', [_c('tr', _vm._l((this.footColumns), function(item) {
    return _c('th', [_vm._v(_vm._s(item))])
  }))])], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)",
      "width": "100px"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дата")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Отработано")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 1 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 1 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 2 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 2 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 3 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 3 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    },
    attrs: {
      "rowspan": "2"
    }
  }, [_vm._v("Дозвон на"), _c('br'), _vm._v(" 4 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув на 4 день")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Апрув")])]), _vm._v(" "), _c('tr', {
    staticClass: "th-level-2"
  }, [_c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    }
  }, [_vm._v("касаний")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(224, 224, 224)"
    }
  }, [_vm._v("звонков")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 249, 196)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 230, 155)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 224, 131)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    }
  }, [_vm._v("лидов")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(255, 217, 106)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    }
  }, [_vm._v("апрув")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    }
  }, [_vm._v("процент")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "background-color": "rgb(129, 199, 132)"
    }
  }, [_vm._v("от валида")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2554792e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/operators/RingingHolds.vue
// module id = 530
// module chunks = 0